import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20traditional%20craft%20collection%20display%20with%20jade%20carvings%20and%20wooden%20artifacts%20on%20dark%20wooden%20surface%2C%20warm%20amber%20lighting%2C%20artistic%20minimalist%20composition%2C%20luxurious%20oriental%20aesthetic%2C%20soft%20dramatic%20shadows%2C%20cream%20and%20gold%20tones&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="掌中之物精品收藏展示"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 tracking-wider">
          掌中之物
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl text-background-50/90 font-light mb-2 md:mb-3 max-w-2xl">
          方寸之间，无限魅力
        </p>
        <p className="text-sm md:text-base text-background-50/70 max-w-xl mb-8 md:mb-10 leading-relaxed">
          专注于每一件值得被双手珍视的精品，从选材到工艺，从触感到故事，每一件掌中之物都承载着独特的温度与价值。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/wenwan-bajian"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            探索精品
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-sm md:text-base font-medium hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            了解品牌
          </Link>
        </div>
      </div>
    </section>
  );
}